module.exports = __webpack_public_path__ + "static/media/018ty@4x.fd582743.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/018ty@4x.png
// module id = 422
// module chunks = 0 1